module.exports = __webpack_public_path__ + "img/je.bcc32cc9.svg";